import Btn from "parts/Btn";
import React from "react";
import Scroll from "react-scroll";

export default function Navbar({ emailMe }) {
    const moveSection = (name) => {
        Scroll.scroller.scrollTo(name, {
            duration: 1500,
            delay: 40,
            smooth: "easeInOutQuint",
            offset: -50,
        });
    };

    return (
        <div className="flex flex-row items-center justify-between w-full">
            <div className="uppercase text-3xl font-semibold">Rizzlle</div>
            <div className="hidden md:inline-flex gap-8">
                <span
                    onClick={() => moveSection("heroContainer")}
                    className="font-medium cursor-pointer transition-colors hover:text-purple-primary"
                >
                    home
                </span>
                <span
                    onClick={() => moveSection("skillContainer")}
                    className="font-medium cursor-pointer transition-colors hover:text-purple-primary"
                >
                    skills
                </span>
                <span
                    onClick={() => moveSection("workContainer")}
                    className="font-medium cursor-pointer transition-colors hover:text-purple-primary"
                >
                    projects
                </span>
                <span
                    onClick={() => moveSection("profileContainer")}
                    className="font-medium cursor-pointer transition-colors hover:text-purple-primary"
                >
                    contact
                </span>
            </div>
            <div className="hidden md:block">
                <Btn handleClick={emailMe}>Hire Me</Btn>
            </div>
            <div className="block md:hidden relative">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8 text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                    />
                </svg>
            </div>
        </div>
    );
}
